import {
  CargillCountry,
  useCargillDefaultCountries,
} from "./useCargillDefaultCountries";

import { sortListByAttribute } from "./sort-utils";
import { useCallback } from "react";
import { useTranslation } from "next-i18next";

interface RequestedPortalCountry {
  active: string;
  country: string;
}

interface FullCountry {
  active: string;
  country: string;
  countryEnglishKey: string;
  translatedCountry: string;
}

/**
 * This hook returns a function that returns in place a merged set of translated
 * countries based on input.
 * @returns
 */
export function useGetTranslatedCountries() {
  const { t, i18n } = useTranslation();
  const other = t("request_access:more_information.other");
  const defaultCountries = useCargillDefaultCountries();

  const getTranslatedCountries = useCallback(
    function getTranslatedCountries(
      requestedPortalCountries: RequestedPortalCountry[]
    ) {
      // Filter to include only the active countries
      const filteredCountries = requestedPortalCountries.filter(
        (item: RequestedPortalCountry) => item.active === "true"
      );

      const translatedCountries = filteredCountries.map((country) => {
        let translated: CargillCountry | undefined = defaultCountries.find(
          (translation) => translation.countryEnglishKey === country.country
        );

        if (!translated) {
          translated = {
            countryEnglishKey: country.country,
            translatedCountry: country.country,
          };
        }

        const combined: FullCountry = { ...country, ...translated };

        return combined;
      });

      const sortedList = sortListByAttribute(
        "translatedCountry",
        translatedCountries,
        other
      );

      return sortedList;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [other, defaultCountries, i18n.language]
  );

  return getTranslatedCountries;
}
